import styled from '@emotion/styled';
import { CardButtonMedium } from '@ferreri/prever-component-lib';

export const CardButtonMediumTruncatedText = styled(CardButtonMedium)`
  min-width: 0;
  overflow: hidden;

  div {
    flex: 1;
    min-width: 0;
  }

  h4 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
